import React from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import * as _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import toastr from 'toastr';
import * as TaskUtilities from '../../../HelperMethods/TaskUtilities';
import { getRecurringFlatTask } from '../../../HelperMethods/Mappers/DbTaskToFlatTask';
import ActionsColumnRenderer from '../../common/ActionsColumnRenderer';
import {
  GRID_OPTIONS,
  LOCAL_STORAGE_RECURRING_TASK_LIST_TABLE_ORDER_KEY,
  LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_VISIBILITY_KEY,
  onDisplayedColumnsChanged,
  onColumnResized,
  RECURRING_TASK_LIST_FILTER_MODEL,
  RECURRING_TASK_LIST_SORT_MODEL,
  TASK_TABLE_COLUMN_MAP,
  TASK_VIEW_TASK_GRID_OPTIONS,
  onDragStopped,
} from '../../../HelperMethods/AgGridConstants';
import { RESOURCES } from '../../../HelperMethods/role-resource-constants';
import { deleteTask } from './redux/actions';
import logUtils from '../../../HelperMethods/LogUtils';
import { getRecurringTaskListTableProperties } from '../../../HelperMethods/LocalStorageUtils';
import FilterMenuButton from '../FilterButton';
import CheckboxExampleToggle from '../../common/RecurringTaskSwitch';
import { getGlobalAttributeToColumn } from './helper';
import { updateUserConfig } from '../../../actions/appActions';

class RecurringTaskList extends React.Component {
  constructor(props) {
    super(props);
    const {
      columnOrder,
      columnVisibility,
      columnWidth,
      filter: filterModel,
      sortModel,
    } = getRecurringTaskListTableProperties(props.userConfig || {});
    const clonedColumnsMap = _.cloneDeep(TASK_TABLE_COLUMN_MAP);
    Object.keys(clonedColumnsMap).forEach((key) => {
      if (!_.isNil(columnVisibility) && !_.isNil(columnVisibility[key])) {
        clonedColumnsMap[key].hide = !columnVisibility[key];
      }
    });
    for (const [field, column] of Object.entries(clonedColumnsMap)) {
      if (columnWidth[field]) {
        Object.assign(column, { width: columnWidth[field] });
      }
    }
    const columnDefs = columnOrder.map((columnKey) => clonedColumnsMap[columnKey]).filter((col) => !!col);
    getGlobalAttributeToColumn(props.globalTaskAttributes, columnOrder, columnVisibility, columnDefs);
    this.state = {
      columnDefs,
      savedFilter: filterModel,
      sortModel,
      updatedStateforFilter: !_.isEmpty(filterModel),
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    // Quick reference checks first (fastest)
    if (this.props.allTasks !== nextProps.allTasks) return true;
    if (this.props.allAreas !== nextProps.allAreas) return true;
    if (this.props.userConfig !== nextProps.userConfig) return true;

    // Array comparison for selectedUserIds (usually small)
    if (!_.isEqual(this.props.selectedUserIds, nextProps.selectedUserIds)) return true;

    // State comparison
    if (!_.isEqual(this.state, nextState)) return true;

    // DO NOT compare selectedTasks - let AgGrid handle selection state internally
    // if (!_.isEqual(this.props.selectedTasks, nextProps.selectedTasks)) return true;

    return false;
  }

  onCellClicked = (event) => {
    // eslint-disable-next-line react/prop-types
    const { onTaskEdit } = this.props;
    if (event.colDef.field === 'taskTypeName') {
      onTaskEdit(event.data);
    }
  };

  onSortChanged = (params) => {
    const updatedSortModel = params.columnApi
      ?.getColumnState()
      .filter((col) => !!col.sort)
      .map((col) => ({ colId: col.colId, sort: col.sort }));
    // const sortModalFromLocal =

    if (updatedSortModel.length > 0) {
      // this code is to fix the bug where savedModel has the colId as workordernumber_1
      updatedSortModel[1] = _.cloneDeep(updatedSortModel[0]);
      if (updatedSortModel[0].colId.endsWith('_1')) {
        updatedSortModel[1].colId = updatedSortModel[1].colId.substr(0, updatedSortModel[1].colId.length - 2);
      } else {
        updatedSortModel[1].colId = `${updatedSortModel[1].colId}_1`;
      }
    }

    this.updateUserConfigFun('RECURRING_TASK_LIST', {
      [RECURRING_TASK_LIST_SORT_MODEL]: JSON.stringify(updatedSortModel),
    });
  };

  onFilterChanged = (params) => {
    const filter = JSON.parse(JSON.stringify(params.api.getFilterModel() || {}));

    if (!_.isEmpty(filter)) {
      this.setState({
        updatedStateforFilter: true,
      });
    }
    if (_.isEmpty(filter)) {
      this.setState({
        updatedStateforFilter: false,
      });
    }
    if (filter) {
      // this code is to fix the bug where FILTER_MODEL has the fieldId as workordernumber_1
      Object.keys(filter).forEach((fieldId) => {
        if (fieldId.endsWith('_1')) {
          const newFieldId = fieldId.substr(0, fieldId.length - 2);
          filter[newFieldId] = filter[fieldId];
        } else {
          const newFieldId = `${fieldId}_1`;
          filter[newFieldId] = filter[fieldId];
        }
      });
      this.props.updateUserConfigAction('RECURRING_TASK_LIST', {
        [RECURRING_TASK_LIST_FILTER_MODEL]: JSON.stringify(filter),
      });
    }
  };

  deleteTask = (id) => {
    const { deleteTaskAction } = this.props;

    deleteTaskAction(id)
      .then(() => {
        toastr.success('Task Deleted Successfully!!');
      })
      .catch((error) => {
        logUtils.logError(error, 'Task Deletion Failed!!');
      });
  };

  handleGridReady = (params) => {
    this.taskListApi = params.api;
  };

  onSelectionChangedOrRowReloaded = (event) => {
    console.log('onSelectionChangedOrRowReloaded start', new Date().toISOString());
    const { onRowSelectionChanged, selectedTasks = [] } = this.props;
    if (event.type === 'rowSelected') {
      const selectedNodes = event.api.getSelectedNodes();
      const selectedTaskIds = selectedTasks.map((task) => task.id);
      const selectedRowsIds = selectedNodes.map((node) => node.data.id);
      const diffIds = selectedRowsIds
        .filter((id) => !selectedTaskIds.includes(id))
        .concat(selectedTaskIds.filter((id) => !selectedRowsIds.includes(id)));
      if (diffIds.length) {
        console.log('onSelectionChangedOrRowReloaded end', new Date().toISOString());
        onRowSelectionChanged(selectedNodes.map((n) => n.data));
      }
    } else if (event.type === 'rowDataChanged') {
      const taskUpdated = [];
      const selectedTasksDict = _.keyBy(selectedTasks, 'id');
      event.api.forEachNode((node) => {
        const reqTasks = selectedTasksDict[node.data.id];
        if (reqTasks) {
          node.setSelected(true);
          taskUpdated.push(node.data);
        }
      });
      onRowSelectionChanged(taskUpdated);
    }
  };

  updateUserConfigFun = async (path, value) => {
    this.props.updateUserConfigAction(path, value);
  };

  onFirstDataRendered = ({ params, sortModel, savedFilter }) => {
    if (sortModel) {
      this.taskListApi?.columnApi?.applyColumnState({
        state: sortModel,
        defaultState: { sort: null },
      });
    }

    if (savedFilter) {
      this.taskListApi?.columnApi?.applyColumnState({
        state: savedFilter,
        defaultState: { sort: null },
      });
    }
  };

  // Add this method to help AgGrid track rows better
  getRowId = (params) => {
    return params.data.id; // Assuming each task has a unique id
  };

  render() {
    // eslint-disable-next-line react/prop-types
    const { allTasks, selectedUserIds, allAreas, userConfig } = this.props;
    const { sortModel, savedFilter } = this.state;
    // eslint-disable-next-line react/prop-types
    const recurringTasks = allTasks.filter(TaskUtilities.isTaskSeriesOfRecurrence);
    let flatRecurringTasks = getRecurringFlatTask(recurringTasks, allAreas);
    if (selectedUserIds && selectedUserIds.length > 0) {
      flatRecurringTasks = flatRecurringTasks.filter((t) => selectedUserIds.includes(t.assignedToUserId));
    }
    const { columnDefs } = this.state;
    return (
      <>
        <FilterMenuButton
          handleClearFilter={() => {
            this.setState(
              {
                updatedStateforFilter: false,
              },
              () => {
                this.taskListApi.setFilterModel({});
              }
            );
          }}
          fromRecurringTaskView
          filterModal={{ updated: this.state.updatedStateforFilter }}
        />
        <div className="ag-theme-balham" style={{ height: '100%' }}>
          <AgGridReact
            {...GRID_OPTIONS}
            {...TASK_VIEW_TASK_GRID_OPTIONS}
            statusBar={{
              statusPanels: [
                {
                  statusPanel: 'agTotalAndFilteredRowCountComponent',
                  align: 'left',
                },
              ],
            }}
            getRowId={this.getRowId}
            columnDefs={columnDefs}
            rowData={flatRecurringTasks}
            onFirstDataRendered={(params) => this.onFirstDataRendered({ params, sortModel, savedFilter })}
            onRowDataChanged={(params) => {
              const sortModal = userConfig?.RECURRING_TASK_LIST?.[RECURRING_TASK_LIST_SORT_MODEL]
                ? JSON.parse(userConfig?.RECURRING_TASK_LIST?.[RECURRING_TASK_LIST_SORT_MODEL])
                : [];
              this.taskListApi?.columnApi?.applyColumnState({
                state: sortModal,
                defaultState: { sort: null },
              });

              if (
                !userConfig?.RECURRING_TASK_LIST?.[LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_WIDTH_KEY] &&
                flatRecurringTasks &&
                flatRecurringTasks.length > 0
              ) {
                params.columnApi.autoSizeAllColumns();
              }
              this.onSelectionChangedOrRowReloaded(params);
            }}
            rowSelection="multiple"
            suppressRowClickSelection="true"
            onRowSelected={this.onSelectionChangedOrRowReloaded}
            onGridReady={this.handleGridReady}
            onDisplayedColumnsChanged={onDisplayedColumnsChanged(
              LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_VISIBILITY_KEY,
              this.updateUserConfigFun,
              'RECURRING_TASK_LIST'
            )}
            onDragStopped={onDragStopped(
              LOCAL_STORAGE_RECURRING_TASK_LIST_TABLE_ORDER_KEY,
              LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_WIDTH_KEY,
              this.updateUserConfigFun,
              'RECURRING_TASK_LIST'
            )}
            onColumnResized={onColumnResized(
              LOCAL_STORAGE_RECURRING_TASK_TABLE_COLUMN_WIDTH_KEY,
              this.updateUserConfigFun,
              'RECURRING_TASK_LIST'
            )}
            frameworkComponents={{
              actionsColumnRenderer: ActionsColumnRenderer,
              CheckboxExampleToggle,
            }}
            context={{
              deleteItem: (task) => {
                this.deleteTask(task.id);
              },
              resource: RESOURCES.ENTITY.TASK,
              filterParentTask: false,
            }}
            onCellClicked={this.onCellClicked}
            onSortChanged={this.onSortChanged}
            onFilterChanged={this.onFilterChanged}
          />
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const taskAttributes = (state.globalAttributeReducer.attributes || []).filter((attr) => attr.entityType === 'task');
  return {
    globalTaskAttributes: taskAttributes,
    allTasks: state.taskViewPageReducer.tasks.items,
    allAreas: state.appReducer.allAreas,
    userConfig: state.appReducer.userConfig,
  };
}

function mapActionToProps(dispatch) {
  return {
    deleteTaskAction: bindActionCreators(deleteTask, dispatch),
    updateUserConfigAction: bindActionCreators(updateUserConfig, dispatch),
  };
}

export default connect(mapStateToProps, mapActionToProps)(RecurringTaskList);
